import { createSlice } from '@reduxjs/toolkit';
import { removeUserAction } from '@common/store/reducers';
import { setColorsReducer } from '@common/store/reducers/graphs/colorReducers';
import {
  setDiagramAggregationReducer,
  setDiagramConfigurationReducer,
  setDiagramFilterReducer,
  setVisualisationTypeReducer,
  toggleStatisticsComparisonReducer,
} from '@common/store/reducers/graphs/configReducers';
import {
  addRegisterReducer,
  dragRegisterReducer,
  moveRegistersReducer,
  removeGraphReducer,
  removeRegisterReducer,
  restoreReducer,
  setSelectedReducer,
} from '@common/store/reducers/graphs/selectionReducers';
import { initialState } from '@common/store/reducers/graphs/types';

export { DefaultColorPalette, maxPaletteSize } from '@common/constants/colorPalette';
export { colorMappingKey } from '@common/store/reducers/graphs/colorReducers';
export {
  type ColorsStoreState,
  type GraphsStoreState,
  type Payload,
} from '@common/store/reducers/graphs/types';

const slice = createSlice({
  initialState,
  name: 'graphs',
  reducers: {
    setColors: setColorsReducer,
    toggleStatisticsComparisonAction: toggleStatisticsComparisonReducer,
    restoreSelectedRegisterDataSeriesGraphAction: restoreReducer,
    setSelectedRegisterDataSeriesGraphAction: setSelectedReducer,
    addRegisterDataSeriesToGraphAction: addRegisterReducer,
    setRegisterVisualisationTypeAction: setVisualisationTypeReducer,
    setDiagramConfigurationAction: setDiagramConfigurationReducer,
    setDiagramRegisterAggregationAction: setDiagramAggregationReducer,
    dragSelectedRegisterAction: dragRegisterReducer,
    removeRegisterAction: removeRegisterReducer,
    removeGraphAction: removeGraphReducer,
    moveRegistersToNextGraphAction: moveRegistersReducer,
    setDiagramFilterAction: setDiagramFilterReducer,
  },
  extraReducers(builder) {
    builder.addCase(removeUserAction, () => initialState);
  },
});

export const {
  addRegisterDataSeriesToGraphAction,
  dragSelectedRegisterAction,
  moveRegistersToNextGraphAction,
  removeGraphAction,
  removeRegisterAction,
  restoreSelectedRegisterDataSeriesGraphAction,
  setColors,
  setDiagramConfigurationAction,
  setDiagramFilterAction,
  setDiagramRegisterAggregationAction,
  setRegisterVisualisationTypeAction,
  setSelectedRegisterDataSeriesGraphAction,
  toggleStatisticsComparisonAction,
} = slice.actions;

export default slice.reducer;
